import { render, staticRenderFns } from "./CoursePurchaseForm.vue?vue&type=template&id=74a90e78&scoped=true&"
import script from "./CoursePurchaseForm.vue?vue&type=script&lang=js&"
export * from "./CoursePurchaseForm.vue?vue&type=script&lang=js&"
import style0 from "./CoursePurchaseForm.vue?vue&type=style&index=0&id=74a90e78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a90e78",
  null
  
)

export default component.exports